import React, { FC, useCallback, useState } from "react";

import { type Place, fetchPlaces } from "@xapp/components";

import {
    AdvancedSearchStepProps,
    AdvancedSearchStep,
    AdvancedSearchResultsStep,
} from "components/Onboarding/components/V3";

import { OnboardingProps } from "../../models";

export interface AdvancedSearchStepContainerProps extends AdvancedSearchStepProps {
    onNoPlaceSelected(props: OnboardingProps): void;
}

export const AdvancedSearchStepContainer: FC<AdvancedSearchStepContainerProps> = (props) => {
    const { ...rest } = props;

    const [placeResults, setPlaceResults] = useState<Place[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const handleSearch = useCallback(
        async (onboardingProps: OnboardingProps) => {
            const abortController = new AbortController();
            const { signal } = abortController;

            const placeQuery = `${onboardingProps.name} ${onboardingProps.searchAddress}`;

            setLoading(true);
            const places = await fetchPlaces(placeQuery, signal).finally(() => {
                setLoading(false);
            });

            // if we only have 1 result, we trust it and move on to the next step (confirm_profile)
            // if we have more than 1 result, we let the user choose the correct one
            if (places.length === 1) {
                const topPlace = places[0];
                const name = topPlace.name;
                const website = topPlace.website;
                const newProps: OnboardingProps = { ...onboardingProps, place: topPlace, name, website };
                console.log("AdvancedSearchStepContainer.onNext", newProps);
                rest.onNext(newProps);
            } else {
                setPlaceResults(places);
            }
        },
        [rest]
    );

    const handleNext = useCallback(
        (onboardingProps: OnboardingProps) => {
            rest.onNext({ ...onboardingProps });
        },
        [rest]
    );

    const handleNoPlaceSelected = useCallback(
        (onboardingProps: OnboardingProps) => {
            props.onNoPlaceSelected({ ...onboardingProps });
        },
        [props]
    );

    return placeResults.length > 0 ? (
        <AdvancedSearchResultsStep
            {...rest}
            places={placeResults}
            loading={loading}
            onNext={handleNext}
            onNoPlaceSelected={handleNoPlaceSelected}
        />
    ) : (
        <AdvancedSearchStep {...rest} loading={loading} onNext={handleSearch} />
    );
};
